import React, { useState, useEffect } from 'react';
import LoadingAnimation from '../LoadingAnimation/LoadingAnimation';
import './SplashScreen.css';

/**
 * SplashScreen component for first-time site visits
 * Shows FLARETECH branded loading animation
 */
const SplashScreen = ({ onComplete }) => {
  // Check session immediately to prevent flash
  const hasVisited = sessionStorage.getItem('hasVisited');
  const [isVisible, setIsVisible] = useState(!hasVisited);
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    if (hasVisited) {
      // Skip splash screen for returning visitors in same session
      onComplete();
      return;
    }

    // Show splash screen for minimum 3 seconds
    const timer = setTimeout(() => {
      setIsFadingOut(true);
      
      // Wait for fade out animation
      setTimeout(() => {
        setIsVisible(false);
        sessionStorage.setItem('hasVisited', 'true');
        onComplete();
      }, 800);
    }, 3000);

    return () => clearTimeout(timer);
  }, [onComplete, hasVisited]);

  if (!isVisible) return null;

  return (
    <div className={`splash-screen ${isFadingOut ? 'splash-screen--fade-out' : ''}`}>
      <div className="splash-screen__content">
        <LoadingAnimation variant="spark-orbit" size="large" />
      </div>
    </div>
  );
};

export default SplashScreen;
